// check if table found
const sizefinderTableNode = document.querySelector('#sizefinder-table');
const sizetable = sizefinderTableNode;

if (sizetable) {

  let stripUnits = (str, defaultValue = 0) => {
    let digits = str.match(/[0-9]+/g);

    if (digits && digits.length > 0) {
      return parseInt(digits.join());
    }

    return defaultValue;
  };

  var destructWeightStructure = (sizetable) => {
    let tableRowList = sizetable.querySelectorAll('tr');

    return Array.from(tableRowList).map((list, index) => {
      var allValues = Array.from(list.querySelectorAll('td')).map((elem) => elem.innerText);
      let weightValueRaw = allValues[0];

      return {
        raw_value: weightValueRaw,
        value: stripUnits(weightValueRaw),
        index: index,
        allValues: allValues,
      };
    });
  };

  var destructHeightStructure = (sizetable) => {
    let tableRow = sizetable.querySelector('tr');
    var allValues = Array.from(tableRow.querySelectorAll('td')).map((elem) => elem.innerText);
    let weightValueRaw = allValues[0];

    return {
      raw_value: weightValueRaw,
      value: stripUnits(weightValueRaw),
      allValues: allValues.map((item, index) => {
        return { value: stripUnits(item), index: index };
      }),
    };
  };

  var findRowFromHeight = (height = targetHeight) => {
    var match = heightStructure.allValues.toReversed().filter((heightConstraint, index) => {
      if (height >= heightConstraint.value) {
        return { height: heightConstraint.value, index };
      }
    });

    /* catch heights greater than limit */
    if (match && match.length === heightStructure.allValues.length) {
      if (height > match[0].value) {
        return false;
      }
    }

    return match ? match[0] : false;
  };

  var findRowFromWeight = (weight = targetWeight) => {
    var match = weightStructure.toReversed().filter((weight_object, index) => {
      if (weight >= weight_object.value) {
        return weight_object;
      }
    });

    /* catch weights greater than limit */
    if (match && match.length === weightStructure.length) {
      if (weight > match[0].value) {
        return false;
      }
    }

    return match ? match[0] : false;
  };

  var weightStructure = destructWeightStructure(sizetable);
  var heightStructure = destructHeightStructure(sizetable);

  var tableRowList = Array.from(sizetable.querySelectorAll('tr'));

  var getSizeRecommendation = (weight, height) => {
    let heightRow = findRowFromHeight(height);
    let weightRow = findRowFromWeight(weight);

    if (!heightRow || heightRow.index === 0 || !weightRow || weightRow.index === 0) {
      return 'out-of-range';
    }

    var targetRowNode = tableRowList[weightRow.index];
    let weightNodeList = Array.from(targetRowNode.querySelectorAll('td'));

    let firstRow = tableRowList[0];
    let activeHeightTd = Array.from(firstRow.querySelectorAll('td'))[heightRow.index];

    return weightStructure[weightRow.index].allValues[heightRow.index];
  };




class SizefinderForm extends HTMLElement {
  constructor() {
    super();
  }

  registerNodes() {
    this.sizeResultContainer = this.querySelector('.sizefinder-recommendation-result');
    this.sizePlaceholder = this.querySelector('.size-result-placeholder');
    this.sizeResultOptions = this.sizeResultContainer.querySelectorAll('.sizefinder-recommendation-result > span');
    this.sizetableForm = this.querySelector('.sizefinder__calculator-form');
    this.inputSizeHeight = this.querySelector('[size-height]');
    this.inputSizeWeight = this.querySelector('[data-size-weight]');

    console.warn(this.sizeResultContainer);
  }


  onKeyup(e) {
      let fieldId = e.target.name;
      let fieldValue = e.target.value;


      if (fieldId == 'size-weight') {
        this.targetWeight = parseInt(e.target.value);
      }

      if (fieldId == 'size-height') {
        this.targetHeight = parseInt(e.target.value);
      }

      let hasValidInputs = false;
      this.sizeResultContainer.setAttribute('visibly-hidden', '');

      if (this.targetWeight && this.targetHeight) {
        if (this.targetWeight > 9 && this.targetHeight > 99) {
          hasValidInputs = true;
        }
      }

      if (!hasValidInputs) {
        this.result_mode = 'when-invalid';
      }

      if (hasValidInputs) {
        this.sizeResultContainer.removeAttribute('visibly-hidden');

        let recSizeValue = getSizeRecommendation(this.targetWeight, this.targetHeight);
        let recSizeConverted = parseInt(recSizeValue);

        if (typeof recSizeValue == 'string') {
          this.result_mode = 'custom';
        }

        if (recSizeValue === 'out-of-range') {
          this.result_mode = 'out-of-range';
        }

        if (Number.isInteger(recSizeConverted)) {
          this.result_mode = 'within-range';
          this.sizePlaceholder.innerText = recSizeValue;
        }
    }

        // swap attribute on parent (sizeResultContainer)
        this.sizeResultOptions.forEach((elem) => {
          elem.classList.add('hidden');
          if (elem.getAttribute('data-status') === this.result_mode) {
            elem.classList.remove('hidden');
          }
        });

        this.sizeResultContainer.setAttribute('data-selected', this.result_mode);
  }


  connectedCallback() {
    this.targetWeight;
    this.targetHeight;

    this.registerNodes();

    this.sizetableForm.addEventListener('keyup', this.onKeyup.bind(this));
  }
}



customElements.define('sizefinder-form', SizefinderForm);


// injection part
  const fieldMarkupHTML = document.querySelector('#sizefinder-template');
  const clone = fieldMarkupHTML.content.cloneNode(true);
  const secondClone = fieldMarkupHTML.content.cloneNode(true);


  // insert
  sizefinderTableNode.before(clone);

  const pdpUspBullets = document.querySelector('.pdp-usp-bullets');
  pdpUspBullets.before(secondClone);

  

}